/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface MaintenanceModeInfo
 */
export interface MaintenanceModeInfo {
    /**
     * 
     * @type {number}
     * @memberof MaintenanceModeInfo
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceModeInfo
     */
    userName: string;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceModeInfo
     */
    activationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceModeInfo
     */
    $type?: MaintenanceModeInfoTypeEnum;
}


/**
 * @export
 */
export const MaintenanceModeInfoTypeEnum = {
    PtwPtw100AppZeroCoreSystemComponentMaintenanceModeInfoPtwPtw100AppZeroCore: 'Ptw.Ptw100.AppZero.Core.SystemComponent.MaintenanceModeInfo, Ptw.Ptw100.AppZero.Core'
} as const;
export type MaintenanceModeInfoTypeEnum = typeof MaintenanceModeInfoTypeEnum[keyof typeof MaintenanceModeInfoTypeEnum];


/**
 * Check if a given object implements the MaintenanceModeInfo interface.
 */
export function instanceOfMaintenanceModeInfo(value?: unknown): value is MaintenanceModeInfo {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(MaintenanceModeInfoTypeEnum)[0];
}

export function MaintenanceModeInfoFromJSON(json: any): MaintenanceModeInfo {
    return MaintenanceModeInfoFromJSONTyped(json, false);
}

export function MaintenanceModeInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaintenanceModeInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'userName': json['userName'],
        'activationDate': !exists(json, 'activationDate') ? undefined : json['activationDate'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function MaintenanceModeInfoToJSON(value?: MaintenanceModeInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'userId': value.userId,
        'userName': value.userName,
        'activationDate': value.activationDate,
        '$type': value.$type,
    });
}

